import { render, staticRenderFns } from "./side_menu.vue?vue&type=template&id=4e6ca078&scoped=true&"
import script from "./side_menu.vue?vue&type=script&lang=js&"
export * from "./side_menu.vue?vue&type=script&lang=js&"
import style0 from "./side_menu.vue?vue&type=style&index=0&id=4e6ca078&prod&lang=scss&scoped=true&"
import style1 from "./side_menu.vue?vue&type=style&index=1&id=4e6ca078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ca078",
  null
  
)

export default component.exports